"use strict";
var coreJsData = require('./_coreJsData');
var maskSrcKey = (function () {
    var uid = /[^.]+$/.exec(coreJsData && coreJsData.keys && coreJsData.keys.IE_PROTO || '');
    return uid ? ('Symbol(src)_1.' + uid) : '';
}());
function isMasked(func) {
    return !!maskSrcKey && (maskSrcKey in func);
}
module.exports = isMasked;
//# sourceMappingURL=_isMasked.js.map